// 房屋租赁列表接口
const getHouseRentList = `/gateway/hc-space/houseRent/getHouseRentList`;
//房屋租赁详情
const getHouseRentDetail = `/gateway/hc-space/houseRent/getHouseRentDetail`;


export {  getHouseRentList, getHouseRentDetail };
